
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#224CA4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.138 22c-.412 0-.803-.032-1.171-.095l-.218-.041c-2.371-.493-3.75-2.309-3.75-5.073V7.209c0-.334.02-.654.06-.96C3.41 3.564 5.255 2 8.139 2h7.725C19.059 2 20.97 3.92 21 7.132v9.659C21 20.048 19.084 22 15.863 22H8.138zm0-18.543c-2.456 0-3.701 1.263-3.701 3.752v9.582c0 2.489 1.245 3.752 3.7 3.752h7.717c2.455 0 3.692-1.263 3.692-3.752V7.209c0-2.489-1.237-3.752-3.692-3.752H8.138zm8.168 12.777c0-.4-.32-.724-.713-.724H8.382a.72.72 0 00-.714.724c0 .4.32.724.714.724h7.21a.718.718 0 00.714-.724zm-.713-4.963a.722.722 0 01.69.339.745.745 0 010 .78.722.722 0 01-.69.339H8.382A.73.73 0 017.739 12a.73.73 0 01.643-.729h7.21zm-3.816-3.5a.73.73 0 00-.643-.729H8.39a.73.73 0 00-.644.729.73.73 0 00.644.728h2.743a.73.73 0 00.643-.728z","fill":"inherit"}})])
          )
        }
      }
    